// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1urpG","inner":"Form_inner__1hGuY","range":"Form_range__2P8Ts","name":"Form_name__2dzCc","actions":"Form_actions__1UcmX"};